/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React, { memo } from 'react';
import './styles.scss';
import { GenericCardBodyProps } from './types';
import { generateID } from '../../base/helper';

/**
 * UI Toolkit Generic Card Body component
 * @public
 */
const Body: React.FC<GenericCardBodyProps> = (props) => {
  const {
    paddingBodyBottom = false,
    paddingBodyTop = false,
    paddingBodyHorizontal = false,
    id = generateID('clientos-ui-toolkit-generic-card-body'),
    children
  } = props;
  return (
    <div
      id={id}
      className={`clientos-ui-toolkit-generic-card__content__body ${paddingBodyBottom ? 'clientos-ui-toolkit-generic-card__content__body__padding-bottom' : ''} ${paddingBodyTop ? 'clientos-ui-toolkit-generic-card__content__body__padding-top' : ''} ${paddingBodyHorizontal ? 'clientos-ui-toolkit-generic-card__content__body__padding-horizontal' : ''}`}
    >
      {children}
    </div>
  );
};
export default memo(Body);
